'use client';

import { c as _c } from "react/compiler-runtime";
import { LogoArbitralis } from '@/shared/components/ui';
import type { WizardStepView } from '../types';
interface WizardHeaderProps {
  steps: WizardStepView[];
}
export const WizardHeader = t0 => {
  const $ = _c(5);
  const {
    steps
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <LogoArbitralis className="[&_img]:h-6 [&_img]:w-auto" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== steps) {
    t2 = steps.map(_temp);
    $[1] = steps;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <div className="border-b border-solid border-neutral-200 px-6 py-6 md:px-20"><div className="mx-auto flex w-full max-w-[1280px] flex-col gap-6">{t1}<ol className="flex w-full max-w-[560px] gap-2 sm:gap-5">{t2}</ol></div></div>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
function _temp(step) {
  return <li key={step.label} className="flex flex-1 flex-col gap-2.5" aria-current={step.active ? "step" : undefined}><span className={`truncate text-[12.5px] ${step.active ? "font-bold" : "font-semibold"} ${step.filled ? "text-brand-600" : "text-neutral-400"} transition-colors`}>{step.label}</span><div className="relative h-1.5 rounded-full bg-neutral-100">{step.filled && <div className="bg-brand-600 os-bar-grow absolute inset-0 origin-left rounded-full" />}{step.active && <div className="ring-brand-600/10 absolute inset-0 rounded-full ring-2" />}</div></li>;
}